const api = '/logistics-service/api/external';

export const fdsPricesContext = {
  getFdsPrices: `${api}/fullyDeliverySupport`,
  updateFdsPrices: `${api}/fullyDeliverySupport`,
  setSellerInfo: `${api}/fullyDeliverySupport/sellerInfo`,
  export: `${api}/fullyDeliverySupport/template`,
  upload: `${api}/fullyDeliverySupport/template`,
};
